import React from 'react';
import './App.css';
import SimpleTabs from './tabs';

function App() {
  return (
    <div className="App">
      <SimpleTabs />
      {/* <SimpleTable />
      <Graph /> */}
    </div>
  );
}

export default App;
